var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card card-custom card-stretch gutter-b"},[_c('div',{staticClass:"card-header border-0"},[_c('h3',{staticClass:"card-title font-weight-bolder text-dark"},[_vm._v("Notificações")]),_c('div',{staticClass:"card-toolbar"},[_c('Dropdown2')],1)]),_c('div',{staticClass:"card-body pt-0"})])
}
var staticRenderFns = []

export { render, staticRenderFns }